<template>
  <div :class="[col]">
    <section class="template-item">
      <div class="thumbnail image-container" v-if="item.thumbnail_cloudinary">
        <!-- <img src="@/core/assets/recentPage.jpg" /> -->
        <img v-lazyload :src="tinyThumb" :data-src="thumbnail" />
      </div>
      <div class="ribbon ribbon-primary" v-if="item && item.status == 'new'">
        <span>{{ $t("generals.new") }}</span>
      </div>
      <div class="ribbon ribbon-warning" v-else-if="item && item.status == 'soon'">
        <span>{{ $t("template.soon") }}</span>
      </div>
      <div class="overlay p-1">
        <button class="btn btn-block btn-light3" @click.stop="onClick">
          {{ $t("generals.preview") }}
        </button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "TemplateItem",
  props: {
    col: {
      type: String,
      default: "col-6 col-md-4 col-lg-3"
    },
    item: Object
  },
  computed: {
    thumbnail() {
      if (this.item && this.item.thumbnail_cloudinary)
        return this.item.thumbnail_cloudinary.replace("http://", "https://");
      return "";
    },
    tinyThumb() {
      if (this.item && this.item.thumbnail_cloudinary_small)
        return this.item.thumbnail_cloudinary_small.replace("http://", "https://");
      return "";
    }
  },
  methods: {
    onClick() {
      this.$emit("select", this.item);
    },
    isAvailable() {
      return this.item.status !== "soon";
    }
  }
};
</script>

<style lang="scss" scoped>
$maxHeight: 200px;
.template-item {
  position: relative;
  @include flex-center;
  // overflow: hidden;
  // cursor: pointer;

  .image-container {
    img {
      border-radius: $radius;
      transition: transform 2s linear;
      width: 100%;
      &:not(.v-lazy-loaded) {
        filter: blur(10px);
      }
    }

    &:hover > img {
      // transform: translateY(calc(-100% - #{$maxHeight}));
    }
  }

  .thumbnail {
    flex: 1;
    max-height: $maxHeight;
    overflow: hidden;
  }

  .ribbon {
    width: 50px;
    height: 50px;
    overflow: hidden;
    position: absolute;
    top: 0;
    right: 0;

    span {
      position: absolute;
      display: block;
      width: 80px;
      padding: 4px 0;
      text-align: center;
      top: 10px;
      right: -24px;

      transform: rotate(45deg);
      font-weight: 500;
      font-size: 7.88882px;
      line-height: 10px;
      color: $textDarkModeHigh;
    }

    &-primary span {
      background-color: $mono3;
    }

    &-warning span {
      background-color: $accent-yellow;
    }
  }

  .overlay {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
    background: $light1;
    transition: opacity 0.2s ease-in-out;
    opacity: 0;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      height: 1px;
      width: 100%;
      background: $light2;
    }
  }

  &:hover {
    .overlay {
      opacity: 1;
    }
  }
}
</style>
